import React from "react";

const EnquiryManagementIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "23",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_708_2008)">
        <path
          d="M11.4967 1.66016C9.71707 1.66071 7.9709 2.14397 6.44418 3.05846C4.91746 3.97295 3.66738 5.28443 2.82708 6.8532C1.98677 8.42197 1.58772 10.1893 1.67241 11.9669C1.75711 13.7446 2.32239 15.4659 3.30806 16.9477L1.6582 21.3373L7.18291 20.3382C8.51324 20.9883 9.97316 21.3298 11.4538 21.3371C12.9345 21.3444 14.3977 21.0174 15.7344 20.3806C17.071 19.7437 18.2468 18.8133 19.1739 17.6588C20.101 16.5043 20.7555 15.1554 21.0888 13.7127C21.4219 12.27 21.4252 10.7707 21.0982 9.32653C20.7714 7.8824 20.1228 6.53066 19.2007 5.3721C18.2787 4.21354 17.107 3.27804 15.7731 2.63534C14.4392 1.99263 12.9774 1.65928 11.4967 1.66016Z"
          stroke={color}
          strokeWidth="1.71"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.22656 9.22747C9.22656 8.77842 9.35972 8.33945 9.6092 7.96608C9.85867 7.5927 10.2133 7.3017 10.6281 7.12987C11.043 6.95802 11.4995 6.91305 11.9399 7.00066C12.3804 7.08826 12.7849 7.30449 13.1024 7.62203C13.42 7.93955 13.6362 8.3441 13.7238 8.78452C13.8114 9.22495 13.7664 9.68145 13.5946 10.0963C13.4228 10.5112 13.1317 10.8658 12.7584 11.1153C12.385 11.3647 11.946 11.4979 11.497 11.4979V13.0115"
          stroke={color}
          strokeWidth="1.71"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4995 16.7959C11.2905 16.7959 11.1211 16.6264 11.1211 16.4175C11.1211 16.2085 11.2905 16.0391 11.4995 16.0391"
          stroke={color}
          strokeWidth="1.71"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 16.7959C11.709 16.7959 11.8784 16.6265 11.8784 16.4175C11.8784 16.2084 11.709 16.0391 11.5 16.0391"
          stroke={color}
          strokeWidth="1.71"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_708_2008">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnquiryManagementIcon;
